import { useMemo } from "react";

export const useQueryParams = () => {
  const queryParams = useMemo(
    () => new URLSearchParams(window.location.search),
    [],
  );

  const isRoutingMode = queryParams.get("routing") !== "disable";
  const isDebugMode = queryParams.get("debug") === "enable";
  const isTimeoutMode = queryParams.get("timeout") !== "false";
  const routeFeatureId = queryParams.get("feature");

  return {
    isRoutingMode,
    isDebugMode,
    isTimeoutMode,
    routeFeatureId,
    queryParams,
  };
};
